import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./ContactScreen.scss";
import { DocsList } from '../../Docs/DocsList/DocsList';
import { LinkMail } from '@randajan/jet-react/dom/link';

export const ContactScreen = (props) => {
    const { } = props;

    return (
        <Block level={0} className="ContactScreen popScreen" caption="Kontakt">
            <span>Se všemi svými požadavky se prosím obracejte na <LinkMail>kontakt@alternatif.cz</LinkMail></span>
            <DocsList/>
        </Block>
    )
}

